const BASE_URL = '/Leadcapture'

export const getEvents = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveEventsAll`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        if (res.status === 204 ) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return await res.json()
    } catch (error) {
        throw error
    }
}
export const getEventsByClient = async (clientId) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveEventsByClientId?clientId=${clientId}`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getDefaultProducts = async () => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveProductListDefaults`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}
export const getGroups = async () => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveProductGroupsOptions`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getSKUs = async () => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveSKUOptions`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getEvent = async (leadCaptureId) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveEvent?leadCaptureId=${leadCaptureId}`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getProductsForEvent = async (leadCaptureId) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveProductsForLeadCapture?leadCaptureId=${leadCaptureId}`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getExhibitorsForEvent = async (leadCaptureId) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExhibitorsForLeadCapture?leadCaptureId=${leadCaptureId}`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return await res.json()
    } catch (error) {
        throw error
    }
}
export const updateEvent = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/AddUpdateLCEvent`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        if (res.status === 200) {
            return "Success"
        }
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getExhibitor = async (exhibitorId) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExhibitor?exhibitorId=${exhibitorId}`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const updateExhibitor = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/AddUpdateLCExhibitor`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        if (res.status === 200) {
            return "Success"
        }
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const retrievePasscode = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrievePasscode`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}


export const checkPasscode = async (passcode) => {
    try {
        const res = await fetch(`${BASE_URL}/VerifyPasscode?passcode=${passcode}`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        if (res.status === 200) {
            return await res.json()
        }
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getConfirmationForm = async (refNumber, sendEmail) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveConfirmationForm?refNumber=${refNumber}&sendEmail=${sendEmail}`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return null;
    } catch (error) {
        throw error
    }
}

export const getQualifierTypeOptions = async () => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveQualifierTypeOption`, {
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getExhibitorQualifiers = async (id) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExhibitorQualifiers?id=` + id, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
    } catch (error) {
        throw error
    }
}
export const getExhibitorLicenses = async (id) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExhibitorLicenses?id=` + id, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
    } catch (error) {
        throw error
    }
}
export const getExhibitorLicensesCount = async (id) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExhibitorLicensesCount?id=` + id, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
    } catch (error) {
        throw error
    }
}
export const getExhibitorLeads = async (id) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExhibitorLeads?limitedExhibitorIds=` + id, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
    } catch (error) {
        throw error
    }
}

export const emailExhibitorLeads = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/EmailExhibitorLeads`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
    } catch (error) {
        throw error
    }
}
export const generateExhibitorLeads = async (id) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExhibitorLeadsFile?limitedExhibitorIds=` + id, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
    } catch (error) {
        throw error
    }
}
export const emailExhibitorInvoices = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/EmailExhibitorInvoices`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
    } catch (error) {
        throw error
    }
}
export const generateExhibitorInvoices = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExhibitorInvoicesFile`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
    } catch (error) {
        throw error
    }
}
export const getExhibitorPasscodes = async (id) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExhibitorPasscodes?limitedExhibitorIds=` + id, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
    } catch (error) {
        throw error
    }
}
export const emailExhibitorPasscodes = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/EmailExhibitorPasscodes`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
    } catch (error) {
        throw error
    }
}
export const generateExhibitorPasscodes = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExhibitorPasscodesFile`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
    } catch (error) {
        throw error
    }
}
export const getLeadCaptureLicenses = async (id) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveLeadCaptureLicenses?id=` + id, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
    } catch (error) {
        throw error
    }
}

export const qualifierCheck = async (id) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveQualifierUsage?id=` + id, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const deleteQualifier = async (id) => {
    try {
        const res = await fetch(`${BASE_URL}/RemoveQualifier?id=` + id, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        if (res.status === 204 || res.status === 200) {
            return "Success"
        }
        else {
            return "error"
        }
    } catch (error) {
        throw error
    }
}
export const saveQualifier = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/AddQualifier`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        if (res.status === 200) {
            return await res.json()
        }
        else if (res.status === 204) {
            return null
        }
        else {
            return await res.json()
        }
    } catch (error) {
        throw error
    }
}
export const saveQualifiers = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/UpdateQualifiers`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        if (res.status === 200) {
            return await res.json()
        }
        else if (res.status === 204) {
            return null
        }
        else {
            return await res.json()
        }
    } catch (error) {
        throw error
    }
}

export const getLicenseCount = async (id) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExhibitorLicensesCount?id=` + id, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        if (res.status === 204 || res.status === 200) {
            return "Success"
        }
        else {
            return "error"
        }
    } catch (error) {
        throw error
    }
}
export const activateLicense = async (id) => {
    try {
        const res = await fetch(`${BASE_URL}/ActivateLicense?id=` + id, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        if (res.status === 204 || res.status === 200) {
            return "Success"
        }
        else {
            return "error"
        }
    } catch (error) {
        throw error
    }
}
export const deactivateLicense = async (id) => {
    try {
        const res = await fetch(`${BASE_URL}/DeactivateLicense?id=` + id, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        if (res.status === 204 || res.status === 200) {
            return "Success"
        }
        else {
            return "error"
        }
    } catch (error) {
        throw error
    }
}
export const getLeadCaptureMonitor = async reqBody => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveLeadCaptureMonitorEvents`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}